import { render, staticRenderFns } from "./indexV2.vue?vue&type=template&id=145dba60"
import script from "./indexV2.vue?vue&type=script&lang=js"
export * from "./indexV2.vue?vue&type=script&lang=js"
import style0 from "./indexV2.vue?vue&type=style&index=0&id=145dba60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports